let materialsSnapshot = [];

export const setMaterialsSnapshot = (data) => {
  if (Array.isArray(data)) materialsSnapshot = data;
  else if (Array.isArray(data?.materials)) materialsSnapshot = data.materials;
};

// `path` is a dotted lookup ("config.materialId" etc.) so callers can pull
// values from anywhere in the per-dip record without us hardcoding shape.
export function getPreviousIds(dips, index, path) {
  const parts = path.split(".");
  return dips
    .slice(0, index)
    .map((d) => parts.reduce((acc, k) => acc?.[k], d))
    .filter(Boolean);
}

export function isSealDip(dip) {
  const material = materialsSnapshot.find((m) => m.id === dip?.config?.slurryId);
  return material?.isSeal || false;
}

export function findLastNonSealDipIndex(dips) {
  for (let i = dips.length - 1; i >= 0; i--) {
    if (!isSealDip(dips[i])) {
      return i;
    }
  }
  return -1;
}

const FOCUSABLE = "input,select,textarea,button,[tabindex]:not([tabindex='-1'])";

const focusableIn = (cell) => {
  if (!cell) return null;
  const candidates = cell.querySelectorAll(FOCUSABLE);
  for (const el of candidates) {
    if (el.disabled) continue;
    if (el.getAttribute("aria-hidden") === "true") continue;
    if (el.type === "hidden") continue;
    if (el.offsetParent === null && el.type !== "checkbox") continue;
    return el;
  }
  return null;
};

export const handleTabDown = (root) => (e) => {
  if (e.key !== "Tab" || !root.current) return;
  const cell = e.target.closest("[data-dip-row][data-dip-col]");
  if (!cell) return;
  const row = Number(cell.getAttribute("data-dip-row"));
  const col = Number(cell.getAttribute("data-dip-col"));
  const nextRow = e.shiftKey ? row - 1 : row + 1;
  const nextCell = root.current.querySelector(
    `[data-dip-row="${nextRow}"][data-dip-col="${col}"]`,
  );
  const target = focusableIn(nextCell);
  if (!target) return; // top/bottom of table — fall back to default Tab.
  e.preventDefault();
  target.focus();
  if (typeof target.select === "function") target.select();
};

const required = true;
const center = true;

export const keys = [
  {
    id: "di-index",
    label: "#",
    center,
  },
  {
    id: "di-prewet",
    label: "Prewet",
    center,
  },
  {
    id: "di-dip",
    label: "Sand",
  },
  {
    id: "di-slurry",
    label: "Slurry",
    required,
  },
  {
    id: "di-movement",
    label: "Movement",
  },
  {
    id: "di-cycle",
    label: "Dry Time",
    required,
  },
  {
    id: "di-lead",
    label: "Lead Time",
    required,
  },
  {
    id: "di-station",
    label: "Station",
  },
];